module.exports = __webpack_public_path__ + "assets/img/dc4b-mw.svg";